module.exports = __webpack_public_path__ + "static/media/img-open_on.6dc5fe23.svg";